import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import './StepFieldWrapper.styles.scss';
import './StepFieldWrapper.styles.responsive.scss';

type StepFieldWrapperProps = {
  className?: string;
  title: string;
  stepNumber: number;
};

const StepFieldWrapper: React.FC<StepFieldWrapperProps> = (props) => {
  const { children, className, title, stepNumber } = props;

  const { t } = useTranslation();

  const classes = classNames('step-field-wrapper', className);

  return (
    <section className={classes}>
      <h4>{`${t('stepTitle', { count: stepNumber })} ${title}`}</h4>
      <div>{children}</div>
    </section>
  );
};

export default StepFieldWrapper;
